import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import SlideMenu from "react-burger-menu/lib/menus/slide";
import { HamburgerButton } from "react-hamburger-button";
import Helmet from "react-helmet";
import {
  Menu,
  Segment,
  Sidebar,
  Button,
  Icon,
  Responsive
} from "semantic-ui-react";
import MainMenu from "./Menu";
import "semantic-ui-css/semantic.min.css";
import "./index.css";

const styles = {
  menu: {
    borderBottom: "none",
    backgroundColor: "white",
    marginBottom: "2px",
    zIndex: 99,
    boxShadow: "0 8px 6px -6px #999"
  }
};

class Navbar extends Component {
  state = { visible: false };

  handleItemClick = (e, { name }) => {
    this.setState({ visible: false });
  };
  toggleVisibility = () => {
    this.setState({
      visible: !this.state.visible
    });
  };
  isMenuOpen = bool => {
    if (this.state.visible !== bool.isOpen) {
      this.setState({ visible: bool.isOpen });
    }
  };
  render() {
    const { activeItem, visible } = this.state;
    return (
      <div>
        <SlideMenu
          isOpen={this.state.visible}
          customBurgerIcon={false}
          customCrossIcon={false}
          onStateChange={this.isMenuOpen}
          right
        >
          <Menu
            pointing
            icon="labeled"
            secondary
            vertical
            style={{ ...styles.menu, height: "100vh", paddingTop: "80px" }}
          >
            <MainMenu
              setInitActive={this.setInitActive}
              handleItemClick={this.handleItemClick}
            />
          </Menu>
        </SlideMenu>
        <Menu fixed="top" pointing secondary size="huge" style={styles.menu}>
          <Menu.Menu>
            <Menu.Item
              as={Link}
              to={"/"}
              name="home"
              onClick={this.handleItemClick}
            >
              Maid To Clean Jax
            </Menu.Item>
          </Menu.Menu>
          <Responsive maxWidth={800} as={Menu.Menu} position="right">
            <Menu.Item>
              <HamburgerButton
                open={visible}
                onClick={this.toggleVisibility}
                height={15}
                width={20}
              />
            </Menu.Item>
          </Responsive>
          <Responsive
            minWidth={800}
            as={MainMenu}
            setInitActive={this.setInitActive}
            handleItemClick={this.handleItemClick}
            position="right"
          />
        </Menu>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Maid Service"
      meta={[
        { name: "description", content: "Sample" },
        { name: "keywords", content: "sample, something" }
      ]}
    />
    <Navbar>
      <div
        style={{
          margin: "0 auto",
          paddingTop: 0
        }}
      >
        {children()}
      </div>
    </Navbar>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js